export default __webpack_public_path__ + "static/SRUS RT198 - Product Specifications & Technical Data-a16e437d5ac6306ba7a306347dc16b08.pdf";